const formatFilter = {
  from: 'date_init',
  to: 'date_end',
  zoneId: 'zone_ids',
  childZone: 'class_ids',
  userType: 'user_type_ids',
  userId: 'user_ids',
  keyCodeId: 'stores_ids',
  userTypeId: 'user_type',
  areas: 'areas_ids',
  departments: 'departments_ids',
  divisions: 'division_ids',
  status: 'status_ids'
}

const formatData: Record<string, string> = {
  areas: 'areas_ids',
  departments: 'departments_ids',
  divisions: 'division_ids',
  zoneId: 'zone_ids',
  childZone: 'class_ids',
  keyCodeId: 'stores_ids',
  userTypeId: 'user_type',
  userId: 'user_ids',
  from: 'date_init',
  to: 'date_end',
  status: 'status_ids'
}
export { formatFilter, formatData }